<template>
  <div class="wrapper">
    <a :href="link" >
    </a>
    <div class="title-box">
      <h4>
        <slot></slot>
      </h4>
      <base-icon icon="heart" :width="1" :height="1"></base-icon>
    </div>
    <base-paragraph>
      <slot name="sub"></slot>
    </base-paragraph>
    <tag-list :tags="tags"></tag-list>
  </div>
</template>

<script>
import BaseParagraph from "@/components/base/BaseParagraph";
import BaseIcon from "@/components/base/BaseIcon";
import TagList from "@/components/portfolio/TagList";

export default {
  name: "PortfolioProject",
  components: {TagList, BaseIcon, BaseParagraph},
  props: ['link', 'imgSrc','tags'],
  data(){
    return {
      ratio: 1,
    };
  },
  watch:{
    height(){
      console.log(this.height);
    }
  },
  computed : {
    imgPath(){
      let imgPath = "url('" + require('@/assets/images/' +  this.imgSrc) +"')";
      return imgPath;
    },
    imgSource(){
      let imgPath =  require('@/assets/images/' +  this.imgSrc);
      return imgPath;
    },
    transition(){
      return 'background-position-y ' + (2 * this.ratio) + 's linear';
    },
  },

  mounted() {
    console.log('Hello')
    const img = new Image();
    img.src = this.imgSource;
    img.onload = () => {
      this.ratio = img.height/img.width;
    }
    img.onerror = () => {
      console.log('error')
    }
    console.log('World');
  }
}
</script>

<style scoped>

.wrapper {
  text-decoration: none;
  display: block;
  padding: 1.5rem;
  border-radius: 10px;
  background-color: #f5f5f5;
  color: black;
  margin-bottom: 1rem;
}

a {
  display: block;
  width: 100%;
  height: 20rem;
  background-image: v-bind(imgPath);
  background-size: 100% auto;
  background-position-y: 0;
}

a:hover {
  background-position-y: 100%;
  transition: v-bind(transition);
}

.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: .5rem;
}

h4 {
  text-transform: capitalize;
}

</style>